import React, { Component, PureComponent } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"

import PieChart from 'react-minimal-pie-chart';
import Stringify from 'react-stringify'

  import api from "../../services/api"
  import "../../assets/styleadmin.css"


class IndexAdmin extends Component {

    state = {
        matriculas:[],
        search:null,
        faturas:[],
        month:parseInt(this.props.match.params.month),
        faturaspagas:[],
        matriculaspagas:[],
        ano:parseInt(this.props.match.params.year),
    
      }
    async UNSAFE_componentWillMount()
    {


      
        this.loadmatriculas();
        this.loadfaturas();
        this.loadfaturapagas();
        this.loadmatpagas();
       
       
    
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      
      if(this.state.month!==prevState.month){
        this.loadmatriculas();
        this.loadfaturas();
        this.loadfaturapagas();
      
      }
    }



    async loadfaturapagas(){
      const {month,ano} = this.state;

      const response = await api.post("admin/relatorio/relatoriopagos", {
        month,ano
      });

      this.setState({
        faturaspagas:response.data
      })
      
    }

    async loadmatpagas(){
      const {month,ano} = this.state;

      const response = await api.post("admin/relatorio/relatoriomatpagos", {
        month,ano
      });

      this.setState({
        matriculaspagas:response.data
      })
      
    }



      async loadfaturas(){
        const {month,ano} = this.state;
        const response = await api.post("/admin/relatorio/faturasmensal",{month,ano});
    
        this.setState({
          faturas:response.data
        })

        localStorage.setItem('datarelatfatpaga',this.state.faturas.paga)
        localStorage.setItem('datarelatfatnaopaga',this.state.faturas.naopaga)
        localStorage.setItem('datarelatfatcancelada',this.state.faturas.cancelado)
        localStorage.setItem('datarelatfatreembolsada',this.state.faturas.refund)
        localStorage.setItem('datarelatfattotal',this.state.faturas.total)
        
        window.reloadfat();
      
      }



      async loadmatriculas(){
        const {month,ano} = this.state;
        const response = await api.post("/admin/relatorio/matriculamensal", {month,ano});
    
        this.setState({
          matriculas:response.data
        })

        localStorage.setItem('matpaga',this.state.matriculas.paga)
        localStorage.setItem('matnaopaga',this.state.matriculas.naopaga)
        localStorage.setItem('mattotal',this.state.matriculas.total)
        localStorage.setItem('matpagaoutrosmeses',this.state.matriculas.outrosmeses)

        window.reloadmat();
      }

  render() {
    
  
    
    return (
      <React.Fragment>
          <Header />
          <div class="col-lg-12">
          <center><h4>Relatório Mensal</h4></center>
          
          <br />
          <center>
            <label id="mes">Consultar por Mes </label>
            <br></br>
            <select id="mes" onChange={e => this.setState({ month: parseInt(e.target.value) })}>
                <option value={1} selected={this.state.month==1}>Janeiro</option>
                <option value={2} selected={this.state.month==2}>Fevereiro</option>
                <option value="3" selected={this.state.month==3}>Março</option>
                <option value="4" selected={this.state.month==4}>Abril</option>
                <option value="5" selected={this.state.month==5}>Maio</option>
                <option value="6" selected={this.state.month==6}>junho</option>
                <option value="7" selected={this.state.month==7}>julho</option>
                <option value="8" selected={this.state.month==8}>agosto</option>
                <option value="9" selected={this.state.month==9}>setembro</option>
                <option value="10" selected={this.state.month==10}>outubro</option>
                <option value="11" selected={this.state.month==11}>novembro</option>
                <option value="12" selected={this.state.month==12}>dezembro</option>
            </select>
            <select onChange={e => this.setState({ ano: parseInt(e.target.value) })}>
              <option value={2019} selected={this.state.ano==2019}>2019</option>
              <option value={2020} selected={this.state.ano==2020}>2020</option>
              <option value={2021} selected={this.state.ano==2021}>2021</option>
              <option value={2022} selected={this.state.ano==2022}>2022</option>
              <option value={2023} selected={this.state.ano==2023}>2023</option>
              <option value={2024} selected={this.state.ano==2024}>2024</option>
              <option value={2025} selected={this.state.ano==2025}>2025</option>
            </select>

          </center>
          <center>
            <a class="btn btn-danger" href={"/admin/relatorio/mensal/"+this.state.month+"/"+this.state.ano}>Recarregar</a>
          </center>
          <br />
         
          <div class="row">
         

              <div class="col d-flex justify-content-center">
              
                <div id="piechart"></div>
                
                
              </div>

              <div class="col-2 d-flex justify-content-center">

                <div class="card" >
                  <div class="card-body">
                    <h5 class="card-title">Matriculas Pagas</h5>
                    <h6 class="card-subtitle mb-2 text-muted">No mês:  {this.state.matriculas.paga}</h6>
                    <h6 class="card-subtitle mb-2 text-muted">Outros meses:  {this.state.matriculas.outrosmeses}</h6>
                    <h6 class="card-subtitle mb-2 text-muted">Total:  {this.state.matriculas.paga+this.state.matriculas.outrosmeses}</h6>
                   {/* <table class="table ">
                    <thead>
                      <tr>
                        <th scope="col">Emitida em</th>
                        <th scope="col">Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.matriculaspagas.janeiro &&
                      this.state.matriculaspagas.janeiro.pago!==0 &&
                      <tr>
                      <th scope="row">Janeiro</th>
                      <td>{this.state.matriculaspagas.janeiro.faturas}</td>
                    </tr>
                      }
                      
                      {this.state.matriculaspagas.fevereiro &&
                      this.state.matriculaspagas.fevereiro.pago!==0 &&
                      <tr>
                      <th scope="row">Fevereiro</th>
                      <td>{this.state.matriculaspagas.fevereiro.faturas}</td>
                    </tr>
                      }


                      {this.state.matriculaspagas.marco &&
                      this.state.matriculaspagas.marco.pago!==0 &&
                        <tr>
                        <th scope="row">Março</th>
                      <td>{this.state.matriculaspagas.marco.faturas}</td>
                        </tr>
                      }
                      {this.state.matriculaspagas.abril &&
                      this.state.matriculaspagas.abril.pago!==0 &&
                        <tr>
                        <th scope="row">Abril</th>
                      <td>{this.state.matriculaspagas.abril.faturas}</td>
                        </tr>
                      }
                      {this.state.matriculaspagas.maio &&
                      this.state.matriculaspagas.maio.pago!==0 &&
                        <tr>
                        <th scope="row">Maio</th>
                      <td>{this.state.matriculaspagas.maio.faturas}</td>
                        </tr>
                      }


                      {this.state.matriculaspagas.junho &&
                      this.state.matriculaspagas.junho.pago!==0 &&
                        <tr>
                        <th scope="row">Junho</th>
                      <td>{this.state.matriculaspagas.junho.faturas}</td>
                        </tr>
                      }
                      {this.state.matriculaspagas.julho &&
                      this.state.matriculaspagas.julho.pago!==0 &&
                        <tr>
                        <th scope="row">Julho</th>
                      <td>{this.state.matriculaspagas.julho.faturas}</td>
                        </tr>
                      }
                      {this.state.matriculaspagas.agosto &&
                      this.state.matriculaspagas.agosto.pago!==0 &&
                        <tr>
                        <th scope="row">Agosto</th>
                      <td>{this.state.matriculaspagas.agosto.faturas}</td>
                        </tr>
                      }
                      {this.state.matriculaspagas.setembro &&
                      this.state.matriculaspagas.setembro.pago!==0 &&
                        <tr>
                        <th scope="row">Setembro</th>
                      <td>{this.state.matriculaspagas.setembro.faturas}</td>
                        </tr>
                      }

                      {this.state.matriculaspagas.outubro &&
                      this.state.matriculaspagas.outubro.pago!==0 &&
                        <tr>
                        <th scope="row">Outubro</th>
                      <td>{this.state.matriculaspagas.outubro.faturas}</td>
                        </tr>
                      }

                       {this.state.matriculaspagas.novembro &&
                      this.state.matriculaspagas.novembro.pago!==0 &&
                        <tr>
                        <th scope="row">Novembro</th>
                      <td>{this.state.matriculaspagas.novembro.faturas}</td>
                        </tr>
                      }

                      {this.state.matriculaspagas.dezembro &&
                      this.state.matriculaspagas.dezembro.pago!==0 &&
                        <tr>
                        <th scope="row">Dezembro</th>
                      <td>{this.state.matriculaspagas.dezembro.faturas}</td>
                        </tr>
                      }
                      
                    </tbody>
                  </table>
                    */}
                  </div>
                </div>
              </div>

              <div class="col d-flex justify-content-center">
                <div id="chart_div"></div>
              </div>
          </div>

          <div class="row">
              


              <div class="col d-flex justify-content-center">
                <div id="centeredall" class="col-lg-5">
<br></br>
                  <center><h5>Faturas Pagas do Mês {new Date(2009,parseInt(this.state.month)-1,10).toLocaleString('default', { month: 'long' })}</h5></center>
               
                  <table class="table ">
                    <thead>
                      <tr>
                        <th scope="col">Mes Vencimento</th>
                        <th scope="col">Qtd Faturas</th>
                        <th scope="col">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.faturaspagas.janeiro &&
                      this.state.faturaspagas.janeiro.pago!==0 &&
                      <tr>
                      <th scope="row">Janeiro</th>
                      <td>{this.state.faturaspagas.janeiro.faturas}</td>
                      <td>{this.state.faturaspagas.janeiro.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                    </tr>
                      }
                      
                      {this.state.faturaspagas.fevereiro &&
                      this.state.faturaspagas.fevereiro.pago!==0 &&
                      <tr>
                      <th scope="row">Fevereiro</th>
                      <td>{this.state.faturaspagas.fevereiro.faturas}</td>
                      <td>{this.state.faturaspagas.fevereiro.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                    </tr>
                      }


                      {this.state.faturaspagas.marco &&
                      this.state.faturaspagas.marco.pago!==0 &&
                        <tr>
                        <th scope="row">Março</th>
                      <td>{this.state.faturaspagas.marco.faturas}</td>
                        <td>{this.state.faturaspagas.marco.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }
                      {this.state.faturaspagas.abril &&
                      this.state.faturaspagas.abril.pago!==0 &&
                        <tr>
                        <th scope="row">Abril</th>
                      <td>{this.state.faturaspagas.abril.faturas}</td>
                        <td>{this.state.faturaspagas.abril.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }
                      {this.state.faturaspagas.maio &&
                      this.state.faturaspagas.maio.pago!==0 &&
                        <tr>
                        <th scope="row">Maio</th>
                      <td>{this.state.faturaspagas.maio.faturas}</td>
                        <td>{this.state.faturaspagas.maio.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }


                      {this.state.faturaspagas.junho &&
                      this.state.faturaspagas.junho.pago!==0 &&
                        <tr>
                        <th scope="row">Junho</th>
                      <td>{this.state.faturaspagas.junho.faturas}</td>
                        <td>{this.state.faturaspagas.junho.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }
                      {this.state.faturaspagas.julho &&
                      this.state.faturaspagas.julho.pago!==0 &&
                        <tr>
                        <th scope="row">Julho</th>
                      <td>{this.state.faturaspagas.julho.faturas}</td>
                        <td>{this.state.faturaspagas.julho.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }
                      {this.state.faturaspagas.agosto &&
                      this.state.faturaspagas.agosto.pago!==0 &&
                        <tr>
                        <th scope="row">Agosto</th>
                      <td>{this.state.faturaspagas.agosto.faturas}</td>
                        <td>{this.state.faturaspagas.agosto.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }
                      {this.state.faturaspagas.setembro &&
                      this.state.faturaspagas.setembro.pago!==0 &&
                        <tr>
                        <th scope="row">Setembro</th>
                      <td>{this.state.faturaspagas.setembro.faturas}</td>
                        <td>{this.state.faturaspagas.setembro.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }

                      {this.state.faturaspagas.outubro &&
                      this.state.faturaspagas.outubro.pago!==0 &&
                        <tr>
                        <th scope="row">Outubro</th>
                      <td>{this.state.faturaspagas.outubro.faturas}</td>
                        <td>{this.state.faturaspagas.outubro.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }

                       {this.state.faturaspagas.novembro &&
                      this.state.faturaspagas.novembro.pago!==0 &&
                        <tr>
                        <th scope="row">Novembro</th>
                      <td>{this.state.faturaspagas.novembro.faturas}</td>
                        <td>{this.state.faturaspagas.novembro.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }

                      {this.state.faturaspagas.dezembro &&
                      this.state.faturaspagas.dezembro.pago!==0 &&
                        <tr>
                        <th scope="row">Dezembro</th>
                      <td>{this.state.faturaspagas.dezembro.faturas}</td>
                        <td>{this.state.faturaspagas.dezembro.pago.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</td>
                        </tr>
                      }
                      
                    </tbody>
                  </table>
                  </div>

              </div>
              
          </div>



          
          


          </div>

      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/relatoriomensal.js